import * as vipData from '../services/vipData';

export default {
  namespace: 'vipData',

  state: {
    userInfo: null,
    memberPageList: null,
    addMember: null,
    levels: [],
    allTotal: 0,
  },

  effects: {
    *queryDealerMemberPage({ payload: { values } }, { call, put }) {
      const response = yield call(vipData.queryDealerMemberPage, values);
      yield put({
        type: 'save',
        payload: {
          memberPageList: response?.data,
        },
      });
    },
    *queryDealerMemberPageNum({ payload: { values } }, { call, put }) {
      const response = yield call(vipData.queryDealerMemberPage, values);
      yield put({
        type: 'save',
        payload: {
          allTotal: response?.data?.total,
        },
      });
    },

    *getLevels(_, { call, put }) {
      const response = yield call(vipData.getLevels);
      yield put({
        type: 'save',
        payload: {
          levels: response?.data,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
